import * as h2Api from '../../h2Api'

export const PRESENTATION_SELECT_STEP = 'EARLY_PRESENTATION_SELECT_STEP'
export const PRESENTATION_FIELD_UPDATE = 'EARLY_PRESENTATION_FIELD_UPDATE'
export const PRESENTATION_FIELD_SAVE = 'EARLY_PRESENTATION_FIELD_SAVE'
export const PRESENTATION_COMPLETE = 'EARLY_PRESENTATION_COMPLETE'

export const setStep = step => (dispatch, getState) => {
  const currentStep = getState().early.presentation.step
  const loadedGameId = getState().early.gameboard.loadedGameId
  const v = (() => {
    switch (currentStep) {
      case 0:
        return dispatch(
          h2Api.post(
            `/early/presentation/${loadedGameId}/summary`,
            getState().early.presentation
          )({ type: PRESENTATION_FIELD_SAVE })
        )
      case 1:
        return dispatch(
          h2Api.post(
            `/early/presentation/${loadedGameId}/pathways`,
            getState().early.presentation
          )({ type: PRESENTATION_FIELD_SAVE })
        )
      case 2:
        return dispatch(
          h2Api.post(
            `/early/presentation/${loadedGameId}/occupations`,
            getState().early.presentation
          )({ type: PRESENTATION_FIELD_SAVE })
        )
      case 3:
        return dispatch(
          h2Api.post(
            `/early/presentation/${loadedGameId}/budget`,
            getState().early.presentation
          )({ type: PRESENTATION_FIELD_SAVE })
        )
      case 4:
        return dispatch(
          h2Api.post(
            `/early/presentation/${loadedGameId}/conclusion`,
            getState().early.presentation
          )({ type: PRESENTATION_FIELD_SAVE })
        ).then(v => {
          dispatch({ type: PRESENTATION_COMPLETE })

          return v
        })
      default:
        return Promise.resolve(true)
    }
  })()

  return v.then(() => Promise.resolve(dispatch({ type: PRESENTATION_SELECT_STEP, step })))
}

export const updateField = (fieldName, value) => dispatch => {
  return Promise.resolve(dispatch({ type: PRESENTATION_FIELD_UPDATE, fieldName, value }))
}
